// ABOUTME: Small colored pill badge showing which config level a value is inherited from.
// ABOUTME: Used in config tables to indicate resolution source (S-P, S-C, G-P, G-C, DEF).

import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

const LEVEL_CONFIG = {
  1: { label: 'S-P', color: '#F97B2C' },  // Shop Product - orange
  2: { label: 'S-C', color: '#F43F7A' },  // Shop Category - pink
  3: { label: 'G-P', color: '#7C3AED' },  // General Product - purple
  4: { label: 'G-C', color: '#3B82F6' },  // General Category - blue
  5: { label: 'DEF', color: '#9ca3af' },   // Default - muted grey
};

export function getLevelLabel(level, t) {
  const labels = {
    1: t('config.levels.shopProduct'),
    2: t('config.levels.shopCategory'),
    3: t('config.levels.generalProduct'),
    4: t('config.levels.generalCategory'),
    5: t('config.levels.default'),
  };
  return labels[level] || '';
}

export function getLevelColor(level) {
  return LEVEL_CONFIG[level]?.color || '#9ca3af';
}

export default function LevelBadge({ level }) {
  const config = LEVEL_CONFIG[level];
  if (!config) return null;

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        fontSize: '0.6rem',
        fontWeight: 600,
        lineHeight: 1,
        px: 0.5,
        py: 0.25,
        borderRadius: '3px',
        color: 'white',
        backgroundColor: config.color,
        ml: 0.5,
        verticalAlign: 'middle',
        opacity: 0.85,
      }}
    >
      {config.label}
    </Box>
  );
}
